import { FC } from 'react';
import { YoutubeScenario } from 'src/types/domain';
import Communicate from './Communicate';
import LearnImmerse from './LearnImmerse';
import * as S from './styles';

type LearnImmerseCommunicateProps = {
  membotScenario: YoutubeScenario;
  trailerScenario: YoutubeScenario;
};

const LearnImmerseCommunicate: FC<LearnImmerseCommunicateProps> = ({
  membotScenario,
  trailerScenario,
}) => {
  return (
    <S.Section>
      <S.SectionContent>
        <Communicate scenario={membotScenario} />
        <LearnImmerse scenario={trailerScenario} />
      </S.SectionContent>
    </S.Section>
  );
};

export default LearnImmerseCommunicate;
